import React, { Fragment } from 'react'
import { Node } from '../../types'
import getValueFromNodes from '../../utilities/getValueFromNode'
import config from '../../config'
import LegalText from '../../components/LegalText/LegalText'

type PaymentInformationGenericLegalProps = {
  nodes: Node[]
};

const PaymentInformationGenericLegal: React.FC<PaymentInformationGenericLegalProps> = ({ nodes }) => (
  <Fragment>
    <LegalText legalText={getValueFromNodes(nodes, 'GENERIC_LEGAL_TEXT')}
      legalLinkText={getValueFromNodes(nodes, 'GENERIC_LEGAL_LINK_TEXT')}
      legalLink={getValueFromNodes(nodes, 'GENERIC_LEGAL_LINK_URL')}/>
    {
      config.paymentMethods.map(pm => (
        <Fragment key={pm.name}>
          <LegalText
            legalText={getValueFromNodes(nodes, `${pm.name}_LEGAL_TEXT`)}
            legalLinkText={getValueFromNodes(nodes, `${pm.name}_LEGAL_LINK_TEXT`)}
            legalLink={getValueFromNodes(nodes, `${pm.name}_LEGAL_LINK_URL`)}/>
        </Fragment>
      ))
    }
  </Fragment>
)

export default PaymentInformationGenericLegal
